import { useQuery } from '@tanstack/react-query';
import { getAttemptQuestionReports } from './api';

/** Per attempt: an attempt belongs to exactly one learner or guest, so the key needs no user id. */
export const attemptQuestionReportsKey = (attemptId: string | undefined) =>
  ['questionReports', 'attempt', attemptId] as const;

/**
 * The caller's reports on one attempt, and whether the author allows reports at all. No retry: when
 * this cannot be loaded the control stays hidden rather than offering something that may be refused.
 */
export function useAttemptQuestionReports(attemptId: string | undefined, enabled = true) {
  return useQuery({
    queryKey: attemptQuestionReportsKey(attemptId),
    queryFn: ({ signal }) => getAttemptQuestionReports(attemptId!, signal),
    enabled: Boolean(attemptId && enabled),
    retry: false,
    staleTime: 60_000,
  });
}
